import type { HTMLAttributes } from 'react';
import { cn } from '../../../lib/utils';

export function TypographyH1({ className, ...props }: HTMLAttributes<HTMLHeadingElement>) {
  return <h1 className={cn('font-body font-semibold text-[32px] leading-normal lg:text-[40px]', className)} {...props} />;
}

export function TypographyH2({ className, ...props }: HTMLAttributes<HTMLHeadingElement>) {
  return <h2 className={cn('font-semibold text-heading-sm leading-heading-sm', className)} {...props} />;
}

export function TypographyH3({ className, ...props }: HTMLAttributes<HTMLHeadingElement>) {
  return <h3 className={cn('font-semibold text-lg leading-body', className)} {...props} />;
}

export function TypographyBody({ className, ...props }: HTMLAttributes<HTMLParagraphElement>) {
  return <p className={cn('font-body text-base leading-6', className)} {...props} />;
}
